import React from "react";
import Responsable from "../../../Responsable";
import BaseSection from "../../BaseSection";
import ScrollOverlayPicExtention from "../scrollOverlays/ScrollOverlayPicExtention";

interface RecruitSection01Props { }

const RecruitSection01: React.FC<RecruitSection01Props> = () => {

  const animationHeight = window.screen.height;
  return (
    <BaseSection fullWidth>
      <Responsable
        pc={
          <ScrollOverlayPicExtention
            picture={"/image/webp/recruit/RecruitMain-Pc.webp"}
            animationHeight={`${animationHeight * 4}px`}
            maxHeight={"100vh"}
            text1={
              <>
                하루를 도전과 창조로 채우는 <br />
                일상 속 혁신가들
              </>
            }
            text2={
              <>
                생각해보니 늘 무언가 가치있는
                <br />
                서비스를 만들며 하루를 보내왔네요.
              </>
            }
            text3={
              <>
                일상을 도전과 창조로 가득 채우는
                <br />그 설렘과 뿌듯함을 함께 하고 싶습니다.
              </>
            }
          />
        }
        tablet={
          <ScrollOverlayPicExtention
            picture={"/image/webp/recruit/RecruitMain-Tablet.webp"}
            animationHeight={`${animationHeight * 3}px`}
            maxHeight={"100vh"}
            text1={
              <>
                하루를 도전과 창조로 채우는 <br />
                일상 속 혁신가들
              </>
            }
            text2={
              <>
                생각해보니 늘 무언가 가치있는
                <br />
                서비스를 만들며 하루를 보내왔네요.
              </>
            }
            text3={
              <>
                일상을 도전과 창조로 가득 채우는
                <br />그 설렘과 뿌듯함을 함께 하고 싶습니다.
              </>
            }
          />
        }
        mobile={
          <ScrollOverlayPicExtention
            picture={"/image/webp/recruit/RecruitMain-Mobile.webp"}
            animationHeight={`${animationHeight * 3}px`}
            maxHeight={"100vh"}
            text1={
              <>
                하루를 도전과 <br />
                창조로 채우는 <br />
                일상 속 혁신가들
              </>
            }
            text2={
              <>
                생각해보니 늘 무언가 가치있는
                <br />
                서비스를 만들며 하루를 보내왔네요.
              </>
            }
            text3={
              <>
                일상을 도전과 창조로 가득 채우는
                <br />그 설렘과 뿌듯함을 함께 하고 싶습니다.
              </>
            }
          />
        }
      />
    </BaseSection>
  );
};

export default RecruitSection01;
